import { Controller } from "@hotwired/stimulus"

// Opens the body-level cooking-mode overlay from the in-page "Cook" button.
// The overlay has to live at body level (outside <main>'s `z-0` stacking
// context) to render truly full-screen, so the button — which lives inside the
// recipe's directions card — reaches it through an outlet rather than being a
// child of the cooking-mode controller.
export default class extends Controller {
  static outlets = ["cooking-mode"]
  static values = { autoOpen: Boolean }

  open() {
    if (this.hasCookingModeOutlet) this.cookingModeOutlet.open()
  }

  // The Kitchen's "Start cooking" links here with ?mode=cook, and the page
  // renders autoOpen for it (the server knows the param even mid-Turbo-visit,
  // before the address bar changes). Open straight into Cook Mode, then drop
  // the param once the visit settles so a refresh doesn't reopen it.
  cookingModeOutletConnected(outlet) {
    if (!this.autoOpenValue) return

    outlet.open()
    document.addEventListener("turbo:load", () => this.forgetCookParam(), { once: true })
  }

  forgetCookParam() {
    const url = new URL(window.location.href)
    if (!url.searchParams.has("mode")) return

    url.searchParams.delete("mode")
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash)
  }
}
